import axios from "axios";
import Config from "src/config";

const v2_actionAutomacao = (id) => {
    return axios({
        method: "get",
        url: `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v2/automacoes/automacao/${id}`
    });
};

export default v2_actionAutomacao;
